import React from 'react';
import { ShieldIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { CHECKOUT_LINKS } from '../data/checkout';
const summaryRows: Array<{
  base: string;
  premium: string;
  strong?: boolean;
}> = [{
  base: '6 tomos + 4 bonos',
  premium: '6 tomos + 4 bonos + 2 Módulos Avanzados',
  strong: true
}, {
  base: '$19.990 ARS',
  premium: '$27.990 ARS',
  strong: true
}, {
  base: 'Acceso Inmediato',
  premium: 'Acceso Inmediato'
}, {
  base: 'Garantía 7 días',
  premium: 'Garantía 7 días'
}, {
  base: '✅ 100 casos con contexto argentino',
  premium: '✅ 100 casos con contexto argentino'
}, {
  base: '✅ Banco completo de evaluaciones',
  premium: '✅ Banco completo de evaluaciones'
}, {
  base: '✅ Kit profesional del docente',
  premium: '✅ Kit profesional del docente'
}, {
  base: '✅ Banco de recursos visuales 2026',
  premium: '✅ Banco de recursos visuales 2026'
}, {
  base: '❌ Sin Criminalística tecnológica avanzada',
  premium: '✅ Genómica, IA forense, 3D y DDHH'
}, {
  base: '❌ Sin formación docente elite',
  premium: '✅ Sistema completo de autoridad y legado docente'
}, {
  base: '❌ Sin análisis de IA y deepfakes',
  premium: '✅ IA, deepfakes, criptomonedas e IoT como evidencia'
}, {
  base: '❌ Sin desarrollo profesional estructurado',
  premium: '✅ Plan de desarrollo docente 2026–2028'
}, {
  base: '❌ Sin sistema de formación de formadores',
  premium: '✅ Programa completo de 20 horas listo para implementar'
}];
export function FinalCTA() {
  return <section className="py-20 bg-navy-900 border-t border-silver/20" data-id="element-60" data-mp="34vez0bqf3i5d">
      <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-61" data-mp="39r3ti0nky8ut">
        <div className="mb-10" data-id="element-62" data-mp="3es1gqrng5t36">
          <p className="text-silver-light font-bold uppercase tracking-wider mb-4" data-id="element-63" data-mp="3et2ux4zrevp4">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown initialHours={23} initialMinutes={21} initialSeconds={12} theme="danger" className="scale-110" data-id="element-64" data-mp="3iqqrech3owj4" />
        </div>

        <h2 className="text-2xl font-extrabold text-white mb-6" data-id="element-65" data-mp="1enfk4djt6s0u">RESUMEN FINAL</h2>

        <p className="text-center text-xs text-silver-dark mb-2 md:hidden" data-id="element-66" data-mp="1sirm960ankrs">
          ← Deslizá para ver la tabla completa →
        </p>
        <div className="overflow-x-auto pb-4 mb-12" data-id="element-67" data-mp="22ebgzp34gdey">
          <div className="min-w-[620px] max-w-3xl mx-auto" data-id="element-68" data-mp="22d03uynsdtb6">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4 items-end" data-id="element-69" data-mp="1xgjha8w8jn07">
              <div className="font-bold text-silver-dark uppercase text-sm tracking-wider text-center" data-id="element-70" data-mp="2bf9cfizhvclx">
                🔍 MEGAPACK CRIMINALÍSTICA LISTO™
              </div>
              <div className="font-bold text-silver-light uppercase text-sm tracking-wider text-center" data-id="element-71" data-mp="27btjoxqjpwei">
                ⭐ MEGAPACK + UPSELL PREMIUM
              </div>
            </div>

            <div className="space-y-2" data-id="element-72" data-mp="d1psa187ocih">
              {summaryRows.map(row => <div key={row.base + row.premium} className="grid grid-cols-2 gap-4 bg-navy-950/70 rounded-xl p-4 items-center border border-silver/15" data-id="element-73" data-mp="2whuv0xyyy7e">
                  <div className={`text-center text-sm ${row.strong ? 'text-white font-bold' : 'text-silver'}`} data-id="element-74" data-mp="3pban5mupsu37">
                    {row.base}
                  </div>
                  <div className={`text-center text-sm ${row.strong ? 'text-silver-light font-bold' : 'text-silver-light'}`} data-id="element-75" data-mp="3fc1ztcucudpt">
                    {row.premium}
                  </div>
                </div>)}

              <div className="grid grid-cols-2 gap-4 bg-transparent p-4 items-center" data-id="element-76" data-mp="3bct3q1bue3r3">
                <div className="text-center" data-id="element-77" data-mp="14ks8kstgzj1v">
                  <a href={CHECKOUT_LINKS.megapack} target="_blank" rel="noopener noreferrer" data-id="element-78" data-mp="14m3byrj06osg">
                    <Button size="sm" variant="outline" className="w-full text-xs" data-id="element-79" data-mp="35m8ckqy9enxt">
                      🔥 QUIERO MI MEGAPACK — $19.990 ARS
                    </Button>
                  </a>
                </div>
                <div className="text-center" data-id="element-80" data-mp="2vnsjiifo94lo">
                  <a href={CHECKOUT_LINKS.upsell} target="_blank" rel="noopener noreferrer" data-id="element-81" data-mp="2ro1vgmhj52ku">
                    <Button size="sm" variant="primary" className="w-full text-xs" data-id="element-82" data-mp="2mqrvwe0ffaja">
                      ⚡ MEGAPACK + UPSELL PREMIUM — $27.990 ARS
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-silver font-medium" data-id="element-83" data-mp="281m0z28mg6h7">
          <div className="flex items-center gap-1.5" data-id="element-84" data-mp="2400j12h8d205">
            <LockIcon className="w-4 h-4 text-silver" data-id="element-85" data-mp="1z05uh5kxgoi9" />
            <span data-id="element-86" data-mp="eh29mqfbyz5a">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-87" data-mp="egk4t5elrclr">
            <ZapIcon className="w-4 h-4 text-silver" data-id="element-88" data-mp="jfwudxwuyxs1" />
            <span data-id="element-89" data-mp="jebxw2qzh4rj">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-90" data-mp="nhicpys5w49m">
            <ShieldIcon className="w-4 h-4 text-silver" data-id="element-91" data-mp="nfxg83maeb94" />
            <span data-id="element-92" data-mp="sfjtue611tig">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-93" data-mp="3rvyns4nbbeka">
            <CreditCardIcon className="w-4 h-4 text-silver" data-id="element-94" data-mp="3rxjflmi8sjeg" />
            <span data-id="element-95" data-mp="3vx222mppp2je">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}